import { Check24Icon as o } from "@material-bank/mb-icons";
import { CenteredBox as s } from "../../../../CenteredBox/CenteredBox.js";
import { jsx as n } from "theme-ui/jsx-runtime";
const a = (e) => {
  const {
    selected: r,
    reserveSpace: t,
    ...i
  } = e;
  return !r && !t ? null : /* @__PURE__ */ n(s, {
    as: "span",
    "aria-hidden": !0,
    ...i,
    sx: {
      display: "inline-flex",
      flexShrink: 0,
      size: 6,
      ...e.sx
    },
    children: r && /* @__PURE__ */ n(o, {})
  });
};
export {
  a as SelectItemIndicator
};
